/* eslint-disable */
import Breakpoint from './breakpoint';

const stickSidebarMulti = () => {
    const breakpoint = new Breakpoint(1280);
    const main = document.querySelector('main');
    const strates = document.querySelector('.strates');
    const sidebar_light = document.querySelector('.sidebar-stick.light');
    const sidebar_dark = document.querySelector('.sidebar-stick.dark');
    const wrapper = document.querySelector('.wrapper-sidebar');

    let top = wrapper.offsetTop;
    let req;
    let offsettop = 0;
    let offsetbottom = 0;
    let header_height = 100;

    const onresize = () => {
        top = wrapper.offsetTop;
        sidebar_light.style.width = `${wrapper.clientWidth}px`;
        sidebar_dark.style.width = `${wrapper.clientWidth}px`;
    }

    // sidebar stick bottom
    let onceBottom = false;
    let oldBottom = null;
    const stickBottom = () => {
        oldBottom = offsetbottom > 1 ? true : false;
        if (oldBottom != onceBottom) {
            if (oldBottom) {
                sidebar_light.classList.add('stickBottom');
                sidebar_dark.classList.add('stickBottom');
            } else {
                sidebar_light.classList.remove('stickBottom');
                sidebar_dark.classList.remove('stickBottom');
            }
        }
        onceBottom = oldBottom;
    }

    // sidebar stick top
    let onceTop = false;
    let oldTop = 0;
    const stickTop = () => {
        oldTop = window.scrollY - top + header_height + 20 > 0 ? true : false;
        if (oldTop != onceTop) {
            if (oldTop) {
                sidebar_light.classList.add('stickTop');
                sidebar_dark.classList.add('stickTop');
            } else {
                sidebar_light.classList.remove('stickTop');
                sidebar_dark.classList.remove('stickTop');
            }
        }
        onceTop = oldTop;
    }

    const frame = () => {
        const bound = main.getBoundingClientRect();
        offsettop = top - window.scrollY
        offsetbottom = -bound.bottom + window.innerHeight;
        if (offsettop <= 100 + 40) offsettop = 100 + 40;
        if (offsetbottom <= 0) offsetbottom = 0;

        stickBottom();

        let clip = strates.getBoundingClientRect().top - header_height - 40;
        sidebar_dark.style.clipPath = `polygon(0 ${clip}px, 100% ${clip}px, 100% 100%, 0 100%)`;
        if (sidebar_dark.offsetHeight > 0) {
            sidebar_light.style.top = `${offsettop}px`;
        } else {
            sidebar_light.style.top = ``;
        }
        sidebar_light.style.bottom = `${offsetbottom}px`;
        if (sidebar_dark.offsetHeight > 0) {
            sidebar_dark.style.top = `${offsettop}px`;
        } else {
            sidebar_dark.style.top = ``;
        }

        sidebar_dark.style.bottom = `${offsetbottom}px`;

        stickTop();

        req = requestAnimationFrame(frame);
    }

    breakpoint.under = () => {
        cancelAnimationFrame(req);
        sidebar_light.style.position = "static";
        sidebar_dark.style.position = "static";
        sidebar_light.classList.remove('sticky');
        sidebar_dark.classList.remove('sticky');
        sidebar_light.style.width = `auto`;
        sidebar_dark.style.width = `auto`;
        window.removeEventListener('resize', onresize);
    }

    breakpoint.above = () => {
        sidebar_light.style.position = "fixed";
        sidebar_dark.style.position = "fixed";
        req = requestAnimationFrame(frame);
        window.addEventListener('resize', onresize, false);
        onresize();
        frame();
    }
}
export default stickSidebarMulti;
